import {useState, useEffect} from 'react';
import {
  getSessionStorage,
  sessionStorageDictionary,
} from '../../sessionStorage';

/**
 * Hook to manage warning banner visibility
 */
export const useWarningBanner = () => {
  const [shouldShowBanner, setShouldShowBanner] = useState(false);

  useEffect(() => {
    // Check if there's a warning banner state in session storage
    const isDismissed = getSessionStorage(
      sessionStorageDictionary.WARNING_BANNER_DISMISSED,
    );
    // Show banner if it exists in session storage and hasn't been dismissed
    setShouldShowBanner(isDismissed === 'false');
  }, []);

  return shouldShowBanner;
};
